import type { ApiOrder } from "@src/api/orders";
import { groupSpMovingsByCell, type SpMoving, type StorePlaceRecommendedCell } from "../../../../../api/storePlaces";

/** Форматирует подпись ячейки места хранения. */
export function formatCellName(cell: { Num: string; SPIndex: string } | undefined): string {
    if (cell == null) {
        return "";
    }

    return cell.SPIndex === "" ? cell.Num : `${cell.Num} - ${cell.SPIndex}`;
}

/** Форматирует рекомендуемые ячейки строки ВЗН УП. */
export function formatRecommendedCells(cells: StorePlaceRecommendedCell[] | undefined): string {
    if (cells == null || cells.length === 0) {
        return "<Не задано>";
    }

    const cellNames = cells.map((cell) => formatCellName(cell)).filter((name) => name !== "");

    if (cellNames.length === 0) {
        return "<Не определены названия ячеек размещения>";
    }

    return cellNames.join(", ");
}

/**
 * Форматирует фактические ячейки размещения строки ВЗН УП по `SpMovings`.
 * @param movements движения размещения по `ArrivalSdbCode`
 */
export function formatPlacedCellsFromSpMovings(movements: SpMoving[] | undefined): string {
    const cells = groupSpMovingsByCell(movements);
    if (cells.length === 0) {
        return "<Не размещено>";
    }

    const labels = cells.map((cell) => formatCellName(cell.StorePlace)).filter((label) => label !== "");
    return labels.length > 0 ? labels.join(", ") : "<Не определены названия ячеек размещения>";
}

/** Форматирует заказ строки ВЗН УП. */
export function formatOrderText(order: ApiOrder | null | undefined): string {
    if (order == null) {
        return "Не задано";
    }

    if (order.ShortNum !== "") {
        return order.ShortNum;
    }

    if (order.Num !== "") {
        return order.Num;
    }

    return order.Name;
}
